import { render } from "./PartnerCompliance.vue?vue&type=template&id=43581979&scoped=true"
import script from "./PartnerCompliance.vue?vue&type=script&lang=js"
export * from "./PartnerCompliance.vue?vue&type=script&lang=js"

import "./PartnerCompliance.vue?vue&type=style&index=0&id=43581979&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43581979"]])

export default __exports__